export default __webpack_public_path__ + "static/media/flowresize.803e17bc.JPG";